// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HZmx","advanced":"styles_advanced__2okf9","text":"styles_text__34qHj"};